import { render, staticRenderFns } from "./AdminOnlineShops.vue?vue&type=template&id=1a7db7b3&"
import script from "./AdminOnlineShops.vue?vue&type=script&lang=js&"
export * from "./AdminOnlineShops.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports